<template>
  <ContainerWithLabel :label="props.field.properties.label">
    <v-container justify="start">
      <v-row>
        <v-col v-row class="pa-0" cols="4">
          <v-text-field
            v-model="context.value.value[props.field.key]"
            :label="label"
            :step="1"
            :min="2"
            :max="30"
            color="primary"
            type="number"
            @update:model-value="onInput"
          />
        </v-col>
        <v-col class="pa-0">
          <v-text-field v-model="parsedField" disabled />
        </v-col>
      </v-row>
    </v-container>
  </ContainerWithLabel>
</template>

<script setup lang="ts">
import { useFormKitContext } from '@formkit/vue'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { INT_TO_NETMASK_MAP } from '@/apps/brelag/common/models/eGateConfig'
import ContainerWithLabel from '@/components/common/ContainerWithLabel.vue'

import type { SchemaFormKitProps } from './types'

const { t, te } = useI18n()
const props = defineProps<SchemaFormKitProps>()
const context = useFormKitContext()

const label = computed(() => {
  if (!props.field.properties?.label) {
    return ''
  }
  return te(props.field.properties?.label)
    ? t(props.field.properties?.label)
    : props.field.properties?.label
})
const parsedField = computed(() => {
  return INT_TO_NETMASK_MAP[context.value.value.value[props.field.key]]
})

function onInput(value) {
  context.value.value.value[props.field.key] = parseInt(value)
}
</script>
